import React, { useState, useEffect, useContext } from "react";
import { Typography, Input, Tooltip, Button, Dropdown, Menu, Icon, message } from "antd";
import "./index.less";
import { platformApi } from "../../../api";
import { ContextAPI } from "../../../ContextAPI";
import { withRouter } from "react-router-dom";
import {
  LeftOutlined
} from '@ant-design/icons';

// Components
import SACTable from "./SACTable";
import WrappedAccessoriesModal from "./SACForm";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;

const Accessories = (props) => {
  const [limit, setLimit] = useState(10);
  const [addFlag, setAddFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [selected, setSelected] = useState(null);
  const [dataSource, setData] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [search, setSearch] = useState(null)
  const { loginCredintials } = useContext(ContextAPI)
  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map(menu => (
      <Item onClick={() => { setLimit(menu), setPage(1) }} key={menu}>
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    setPrimaryData()
    loginCredintials.roleAccess && loginCredintials.roleAccess.map(each => {
      if (each.subModule === 'sac') {
        if (each.access.create) {
          setCreateAccess(true)
        }
        if (each.access.update) {
          setModifyAccess(true)
        }
      }
    })
  }, []);

  useEffect(() => {
    setPrimaryData(search);
  }, [page, limit, search])

  const setPrimaryData = (search, val) => {
    setSpinning(true);
    platformApi
      .post("/api/sac/get", { page: val ? val : page, size: limit, searchString: search })
      .then(result => {
        setSpinning(false);
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setData(response.data.sac);
            setCount(response.data.count);
          } else {
            message.error("Unable to fetch SAC Code", 2);
          }
        } else {
          message.error("Unable to fetch SAC Code", 2);
        }
      })
      .catch(error => {
        setSpinning(false);
        console.error("Error on SAC Code : ", error);
        message.error("Unable to fetch SAC Code", 2);
      });
  }

  const deleteData = id => {
    setSpinning(true);
    let temp = page != 1 && dataSource.length === 1;
    // if (page != 1 && dataSource.length === 1) {
    //   setPage(page - 1)
    // }
    platformApi
      .delete(`/api/sac/${id}`)
      .then(result => {
        setSpinning(false);
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            if (temp) {
              setPage(1)
              setPrimaryData(null, 1);
            }
            else {
              setPrimaryData();
            }
            message.success("Deleted Sucessfully", 2);
          } else {
            message.error("Unable to delete SAC Code", 2);
          }
        } else {
          message.error("Unable to delete SAC Code", 2);
        }
      })
      .catch(error => {
        setSpinning(false);
        message.error("Unable to delete SAC Code", 2);
        console.error("Error on SAC Code : ", error);
      });
  };

  const addData = sac => {
    setSpinning(true);
    if (sac.id) {
      platformApi
        .put(`/api/sac/${sac.id}`, sac)
        .then(result => {
          setSpinning(false);
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              dataSource.some((obj, index) => {
                if (obj.id === sac.id) dataSource[index] = response.data;
              });
              setData([]);
              setData(dataSource);
              message.success("SAC Code saved successfully", 2);
            } else {
              message.error("Unable to save SAC Code", 2);
            }
          } else {
            message.error("Unable to save SAC Code", 2);
          }
        })
        .catch(error => {
          message.error("Unable to save SAC Code", 2);
          console.error("Error on SAC Code : ", error);
          setSpinning(false);
        });
    } else {
      platformApi
        .post("/api/sac/", sac)
        .then(result => {
          setSpinning(false);
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              setData([...dataSource, response.data]);
              setCount(count + 1);
              message.success("SAC Code added successfully", 2);
            } else {
              message.error("Unable to add SAC Code", 2);
            }
          } else if (data.code == 500 && data.err.code == 200) {
            message.error("SAC Code already exists", 2);
          } else {
            message.error("Unable to add SAC Code", 2);
          }
        })
        .catch(error => {
          message.error("Unable to add SAC Code", 2);
          console.error("Error on SAC Code : ", error);
          setSpinning(false);
        });
    }
  };

  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          SAC Code [{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                  <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Codes"
          onSearch={(event) => {
            setPage(1)
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null)
              setPage(1)
            }
          }}
        />
        <Button
          onClick={() => {
            setEditFlag(true);
            setAddFlag(true);
          }}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Codes
        </Button>
      </div>
      <SACTable
        pagination={{
          onChange: (page) => {
            setPage(page);
          },
          pageSize: limit,
          defaultCurrent: 1,
          total: count,
          current: page,
          showQuickJumper: true
        }}
        openModal={(index, editable) => {
          setSelected(index);
          setEditFlag(editable);
          setAddFlag(true);
        }}
        delete={id => deleteData(id)}
        dataSource={dataSource}
        spinner={{ spinning }}
      />
      <WrappedAccessoriesModal
        data={dataSource[dataSource.findIndex(data => data.id === selected)]}
        emitData={data => addData(data, selected)}
        open={addFlag}
        editable={editFlag}
        close={() => {
          setSelected(null);
          setAddFlag(false);
        }}
        modify={modifyAccess}
      />
    </div>
  );
}

export default withRouter(Accessories)